import React from "react";
import { sanitizeUrl, sanitizeCssValue } from "../sanitize";

const ImageBlock = {
  label: "Image",
  fields: {
    url: {
      type: "text",
      label: "Image URL",
    },
    alt: {
      type: "text",
      label: "Alt text",
    },
    width: {
      type: "text",
      label: "Width (e.g. 100%, 300px)",
    },
    height: {
      type: "text",
      label: "Height (e.g. auto, 200px)",
    },
    objectFit: {
      type: "radio",
      label: "Object Fit",
      options: [
        { label: "Cover", value: "cover" },
        { label: "Contain", value: "contain" },
        { label: "Fill", value: "fill" },
        { label: "None", value: "none" },
      ],
    },
  },
  defaultProps: {
    url: "",
    alt: "",
    width: "100%",
    height: "auto",
    objectFit: "cover",
  },
  render: ({ url, alt, width, height, objectFit }) => {
    if (!url) {
      return (
        <div
          style={{
            width: sanitizeCssValue(width, "100%"),
            height: "200px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f3f4f6",
            border: "2px dashed #d1d5db",
            borderRadius: "8px",
            color: "#9ca3af",
          }}
        >
          No image URL provided
        </div>
      );
    }

    return (
      <img
        src={sanitizeUrl(url)}
        alt={alt || ""}
        style={{
          width: sanitizeCssValue(width, "100%"),
          height: sanitizeCssValue(height, "auto"),
          objectFit: objectFit || "cover",
          display: "block",
        }}
      />
    );
  },
};

export default ImageBlock;
